import React from 'react';
import '../../styles/about.css'; // Adjust path as needed

function Location() {
  return (
    <div className="loc-section-container">
      {/* Header with Lines */}
      <div className="loc-header-wrapper">
        <div className="loc-header-grid">
          <h1 className="loc-main-title">ABOUT</h1>
          
        </div>
      </div>

      {/* Main Content: Map + Description */}
      <div className="loc-content-grid">
        {/* Left Side: Map */}
        <div className="loc-map-container">
          <iframe 
            title="Victoria Sports Club Location Map"  // <--- ADD THIS LINE
            className="loc-iframe"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3860.251433282245!2d121.0347893758461!3d14.64166257551522!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3397b70f00000001%3A0xc6444c1066730811!2sVictoria%20Sports%20Tower%20Station%202!5e0!3m2!1sen!2sph!4v1709800000000!5m2!1sen!2sph" 
            allowFullScreen="" 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade">
          </iframe>
        </div>

        {/* Right Side: Text Details */}
        <div className="loc-text-container">
          <h1 className="loc-hotel-name">Victoria Sports Tower</h1>
          <p className="loc-address">
            799, Victoria Sports Tower, EDSA Southbound, 799 Epifanio de los Santos Ave, South Triangle, Quezon City, 1103 Metro Manila
          </p>
         <div className="loc-description-box">
            <p>
              Victoria Sports aims to be a one-stop training facility for fitness
              enthusiasts and athletes. Our membership benefits ensure that we
              fit every active lifestyle. Enjoy access to a 50-meter indoor lap
              pool, six private gyms and complete beauty and wellness facilities,
              it is the largest indoor sports facility in Quezon City.
            </p>

            {/* Mission & Vision */}
            {/* <div className="loc-mv-grid">

              <div className="loc-mv-card">
                <h3>Our Mission</h3>
                  <p>
                    Victoria Sports Club provides high-quality fitness and wellness programs, 
                    modern facilities, and personalized support to help individuals and families 
                    achieve healthier and more active lifestyles.
                  </p>
              </div>

              <div className="loc-mv-card">
                <h3>Our Vision</h3>
                  <p>
                    To be a leading fitness and wellness destination, inspiring healthier 
                    communities through excellence, innovation, and exceptional member experiences.
                  </p>
              </div>

            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Location;